module.exports = __webpack_public_path__ + "static/media/tournament-card-bg.005039b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Tournaments/Account/Card/images/tournament-card-bg.png
// module id = 1848
// module chunks = 103